'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'boombox';
var width = 576;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M32 0l512 0 0 160 32 0 0 320-576 0 0-320 32 0 0-160zM80 160l80 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 80 0 0-112-416 0 0 112zm336 64a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm-256 0a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm304-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;